import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { toast } from "react-toastify";
import {
  handleSaveCampus,
  handleUpdateCampus,
  handleGallerySelect,
} from "./hooks/campusesHandlers";
import GalleryPickerField from "../../components/ImageGallery/GalleryPickerField";
import GalleryVideoField from "../../components/videoGallery/GalleryPickerField"
import VideoGalleryfeild from "../../components/MinistryVideo/GalleryPickerField"
import GoogleMapInput from "../../components/MapInput/MapInput";
import {AllCampusesHooks} from "./hooks/campusesHandlers"
const CampusesField = ({ church, rowData = {}, onClose }) => {
  const dispatch = useDispatch();
  const currentUrl = window.location.href;
  const [galleryData, setGalleryData] = useState({});
  const [formKey, setFormKey] = useState(0);

  const [campusName, setCampusName] = useState("");
  const [campusDescription, setCampusDescription] = useState("");
  const [tempUrls, setTempUrls] = useState({ web: "", tablet: "", mobile: "" });
  const [address, setAddress] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [contactPhone, setContactPhone] = useState("");
  const [website, setWebsite] = useState("");
  const US_DEFAULT = {
    lat: 40.7128,
    lng: -74.0060,
  };
  const [selectedLocation, setSelectedLocation] = useState({
    lat: rowData?.latitude ?? US_DEFAULT.lat,
    lng: rowData?.longitude ?? US_DEFAULT.lng,
    address: rowData?.address ?? "",
  });


  const resetCampusForm = () => {
    setCampusName("");
    setCampusDescription("");
    setAddress("");
    setLatitude("");
    setLongitude("");
    setContactEmail("");
    setContactPhone("");
    setWebsite("");
    setFormKey(prev => prev + 1); // 🔥 force full re-render

    setGalleryData({});
    setTempUrls({ web: "", tablet: "", mobile: "" });

    setSelectedLocation({
      lat: 20.5937,
      lng: 78.9629,
      address: "",
    });
  };



  useEffect(() => {
    if (!rowData || (!rowData.latitude && !rowData.longitude)) return;

    setSelectedLocation({
      lat: Number(rowData.latitude),
      lng: Number(rowData.longitude),
      address: rowData.address || "",
    });

    setLatitude(rowData.latitude || "");
    setLongitude(rowData.longitude || "");
    setAddress(rowData.address || "");
  }, [rowData]);




  const onSaveOrUpdate = (onClose) => {
    if (!church?._id) return toast.error("Missing church ID!");
    if (!campusName.trim()) return toast.error("Please enter campus name");

    const campusData = {
      church_id: church._id,
      name: campusName,
      description: campusDescription,
      campusObjId: rowData?.campusObjId,

      address,
      latitude,
      longitude,
      contactemail: contactEmail,
      contactphone: contactPhone,
      website,
    };


    if (rowData?.campusObjId) {
      // Update flow with gallery update
      handleUpdateCampus(dispatch, campusData, galleryData, (response) => {
        if (response.type === 1) {
          toast.success("Campus updated successfully!");
          onClose?.();
        } else {
          toast.error(response.message || "Update failed");
        }
      });
    } else {
      // Save + gallery flow
      handleSaveCampus(dispatch, campusData, tempUrls, galleryData,thumbnailImage,isLive,isDefault, (response) => {
        if (response.type === 1) {
          toast.success("Campus saved successfully!"); // ✅ visible immediately
          resetCampusForm();   // ✅ CLEAR ALL FIELDS

          onClose?.(); // ✅ modal closes
        } else {
          toast.error(response.message || "Save failed");
        }
      });
    }
  };
    const [thumbnailImage, setThumbnailImage] = useState(null);
    const [isLive,setIslive] =useState(false)
    const [isDefault,setIsDefault] =useState(false)
  const handleThumbSelect = (img) => {
    setThumbnailImage(img?.target?.value?.[0]?.id);
  };
  const isEmpty = (value) =>
    value === undefined || value === null || value.toString().trim() === "";
  const validateCampusFields = () => {
    if (!church?._id) {
      toast.error("Church is required");
      return false;
    }

    if (isEmpty(campusName)) {
      toast.error("Campus Name is required");
      return false;
    }

    if (isEmpty(campusDescription)) {
      toast.error("Campus Description is required");
      return false;
    }

    if (isEmpty(address)) {
      toast.error("Campus Address is required");
      return false;
    }

    if (isEmpty(latitude) || isEmpty(longitude)) {
      toast.error("Please select campus location on map");
      return false;
    }

    // Cover image required only while creating
    if (!rowData?.campusObjId && !tempUrls?.web && !galleryData?.galleryObjId) {
      toast.error("Cover Image is required");
      return false;
    }

    return true;
  };
  const [apiCampus, setApiCampus] = useState(null);
  const {fetchAllCampuses} =AllCampusesHooks();
  useEffect(() => {
    if (!rowData?.campusObjId || !church?._id) return;

    fetchAllCampuses(
      1,
      100,
      {},
      (res) => {
        if (!res?.data?.length) return;

        const campus = res.data.find(
          (c) => c.campusObjId === rowData.campusObjId
        );

        if (campus) {
          setApiCampus(campus);
        }
      },
      church._id
    );
  }, [rowData?.campusObjId, church?._id]);
  useEffect(() => {
    if (!apiCampus) return;

    setCampusName(apiCampus.campusName || "");
    setCampusDescription(apiCampus.rawCampusDescription || "");
    setAddress(apiCampus.address || "");
    setLatitude(apiCampus.latitude || "");
    setLongitude(apiCampus.longitude || "");
    setContactEmail(apiCampus.contactemail || "");
    setContactPhone(apiCampus.contactphone || "");
    setWebsite(apiCampus.website || "");

    setSelectedLocation({
      lat: apiCampus.latitude || 20.5937,
      lng: apiCampus.longitude || 78.9629,
      address: apiCampus.address || "",
    });

    // 🔹 Cover image
    if (apiCampus?.coverImage) {
      setTempUrls({
        web: apiCampus.coverImage,
        tablet: apiCampus.coverImage,
        mobile: apiCampus.coverImage,
      });
    }

    // 🔹 Gallery
    setGalleryData({
      campusGalleryObjId: apiCampus.campusGalleryObjId || null,
      galleryObjId: apiCampus.galleryObjId || null,
      mobilesetting: apiCampus.mobilesetting || "fill",
      tabletsetting: apiCampus.tabletsetting || "contain",
      dashboardsetting: apiCampus.dashboardsetting || "cover",
      default: apiCampus.default === true || apiCampus.default === "true",
    });
  }, [apiCampus]);
  const cleanHtmlContent = (htmlContent) => {
    if (!htmlContent) return htmlContent;

    // Remove ALL color-related styles and formatting
    return htmlContent
      // Remove background-color styles
      .replace(/style="[^"]*background-color[^;"]*;?[^"]*"/gi, '')
      // Remove color styles
      .replace(/style="[^"]*color:[^;"]*;?[^"]*"/gi, '')
      // Remove any style attribute that contains color (more comprehensive)
      .replace(/style="[^"]*(color|background|background-color)[^"]*"/gi, '')
      // Remove any style attributes with single quotes
      .replace(/style='[^']*'/gi, '')
      // Remove empty style attributes
      .replace(/style=""/gi, '')
      // Remove any span tags that might have had styling (keeps span but removes all styles)
      .replace(/<span[^>]*>/gi, '<span>')
      // Remove any font tags that might bring color
      .replace(/<font[^>]*>/gi, '')
      .replace(/<\/font>/gi, '')
      // Also remove any color-related CSS classes
      .replace(/class="[^"]*color[^"]*"/gi, '');
  };
  return (
    <div className="px-4 text-white">
      <div className="flex justify-end mb-4">
        <button
         onClick={() => {
          if (!validateCampusFields()) return;
          onSaveOrUpdate(onClose);
        }}

          className="bg-yellowish text-black font-medium rounded-xl py-2 px-6 text-[12px]"
        >
          {rowData?.campusObjId ? "Update Campus" : "Save Campus"}
        </button>
      </div>

      <div className="mb-4">
        <label className="text-[12px] text-greyish font-medium">Church *</label>
        <input
          type="text"
          readOnly
          value={church?.churchName || ""}
          className="bg-blackish p-2 w-full text-white text-[14px] mt-2 rounded-md h-10"
        />
      </div>

      <div className="mb-4">
        <label className="text-[12px] text-greyish font-medium">Campus Name *</label>
        <input
          type="text"
          value={campusName}
          onChange={(e) => setCampusName(e.target.value)}
          placeholder="Enter Campus Name"
          className="bg-blackish p-2 w-full text-white text-[14px] mt-2 rounded-md h-10"
        />
      </div>
{/* Campus Description */}
<div className="mb-4 md:col-span-2 col-span-1">
  <label className="text-[12px] text-greyish font-medium leading-4">
    Campus Description
  </label>

  <div className="mt-2">
    <ReactQuill
      value={campusDescription}
      onChange={(value) => {
        const cleanedValue = cleanHtmlContent(value); // Clean the HTML content
        setCampusDescription(cleanedValue);
      }}
      theme="snow"
      placeholder="Enter campus description..."
      className="text-white text-[14px] font-medium rounded-md bg-blackish quill-custom"
    />
  </div>
</div>
{/* ADDRESS */}
{/* Google Map Picker (Campus Location) */}
<div className="md:col-span-2 col-span-1 mb-4">
  <GoogleMapInput
    defaultLocation={{
      lat: selectedLocation?.lat ?? 40.7128,
      lng: selectedLocation?.lng ?? -74.0060,
    }}
    onLocationChange={({ lat, lng, address }) => {
      setSelectedLocation({ lat, lng, address });
      setAddress(address);
      setLatitude(lat);
      setLongitude(lng);
    }}
  />
</div>

{/* Campus Address */}
<div className="md:col-span-2 col-span-1 mb-4">
  <label className="text-[12px] text-greyish font-medium leading-4">
    Campus Address *
  </label>
  <input
    type="text"
    placeholder="Enter Campus Address"
    value={selectedLocation.address || ""}
    onChange={(e) => {
      setAddress(e.target.value);
      setSelectedLocation((prev) => ({ ...prev, address: e.target.value }));
    }}
    className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
  />
</div>

{/* Hidden Latitude */}
<div className="hidden">
  <input type="text" value={selectedLocation.lat || ""} readOnly />
</div>

{/* Hidden Longitude */}
<div className="hidden">
  <input type="text" value={selectedLocation.lng || ""} readOnly />
</div>



{/* CONTACT EMAIL */}
<div className="mb-4">
  <label className="text-[12px] text-greyish font-medium">Contact Email</label>
  <input
    type="email"
    value={contactEmail}
    onChange={(e) => setContactEmail(e.target.value)}
    placeholder="Enter email"
    className="bg-blackish p-2 w-full text-white text-[14px] mt-2 rounded-md h-10"
  />
</div>

{/* CONTACT PHONE */}
<div className="mb-4">
  <label className="text-[12px] text-greyish font-medium">Contact Phone</label>
  <input
    type="text"
    value={contactPhone}
    onChange={(e) => setContactPhone(e.target.value)}
    placeholder="Enter phone"
    className="bg-blackish p-2 w-full text-white text-[14px] mt-2 rounded-md h-10"
  />
</div>

{/* WEBSITE */}
<div className="mb-4">
  <label className="text-[12px] text-greyish font-medium">Website</label>
  <input
    type="text"
    value={website}
    onChange={(e) => setWebsite(e.target.value)}
    placeholder="Enter website"
    className="bg-blackish p-2 w-full text-white text-[14px] mt-2 rounded-md h-10"
  />
</div>



<GalleryPickerField
  key={formKey}   // 🔥 forces component reset

  label="Cover Image"
  name="galleryImage"
  church={church}
  rowData={rowData}
  value={galleryData?.galleryObjId || ""}
  handleChange={(imageSet) =>
    handleGallerySelect({ imageSet, setTempUrls, setGalleryData })
  }
/>

{
currentUrl.toLowerCase().includes("addministryfield")?


<VideoGalleryfeild
        label="Select Video"
        name="thumbnail"
        church={church}
        handleChange={handleThumbSelect}
      />
      :
      <GalleryVideoField
        label="Select Video"
        name="thumbnail"
        church={church}
        handleChange={handleThumbSelect}
      />
}
         <div className="flex items-center gap-4 mt-4">
        <input
          type="checkbox"
          id="liveCheckbox"
          className="w-4 h-4 cursor-pointer accent-yellowish appearance-none border border-gray-300 rounded-full checked:bg-yellow-500 checked:border-yellow-500"
          checked={isLive}
          onChange={(e) => setIslive(e.target.checked)}
        />
        <label htmlFor="liveCheckbox" className="cursor-pointer select-none">
          Live
        </label>

        <input
          type="checkbox"
          id="defaultCheckbox"
          className="w-4 h-4 cursor-pointer accent-yellowish appearance-none border border-gray-300 rounded-full checked:bg-yellow-500 checked:border-yellow-500"
          checked={isDefault}
          onChange={(e) => setIsDefault(e.target.checked)}
        />
        <label htmlFor="defaultCheckbox" className="cursor-pointer select-none">
          Default
        </label>
      </div>
    </div>
  );
};

export default CampusesField;
